import { createAsyncThunk } from "@reduxjs/toolkit";

import { axios, timezone as tz } from "@/utils";
const _timezone = tz || "Asia/Calcutta";

export const getPartnershipPage = createAsyncThunk<any, any>(
  "getPartnershipPage",
  ({ slug, ignoreTimezone }) => {
    let url = `${process.env.NEXT_PUBLIC_LOCAL_API_URL}landingpage/v2/${slug}/`;
    if (!ignoreTimezone) url = `${url}?timezone=${_timezone}`;
    return axios.get(url);
  }
);
